import {Map} from 'immutable'

import firedux from '../firedux'

import {
  SESSION_STATUSES,
  STRIPE_PAYOUT_REQUESTS_ENDPOINT,
  PAYOUT_REQUEST_STATUSES,
  EXPERT_SESSIONS_ENDPOINT,
  PAY_AS_YOU_GO_VALUE
} from '../../config/constants'

const updateSessionWithPayoutRequest = (payoutRequestStatus, sessionId, snapshot) => {
  const requestId = snapshot.key()
  const ENDPOINT = `${EXPERT_SESSIONS_ENDPOINT}/${sessionId}`

  let sessionUpdates = {status: SESSION_STATUSES.BOOKED}

  if (payoutRequestStatus === PAYOUT_REQUEST_STATUSES.PENDING) {
    sessionUpdates.pendingPayoutRequest = requestId
  }

  return firedux.ref.child(ENDPOINT).update(sessionUpdates)
    .then(() => requestId)
}

export default (payoutRequestData, shouldUpdateSession = true, shouldAllowExpertless = false) => {
  if (!payoutRequestData) return
  if (!payoutRequestData.card) return
  if (!payoutRequestData.amount) return
  if (!payoutRequestData.user) return
  if (!shouldAllowExpertless && !payoutRequestData.expert) return
  if (!payoutRequestData.sessionId) return

  let status = PAYOUT_REQUEST_STATUSES.REQUESTED

  if (payoutRequestData.amount === PAY_AS_YOU_GO_VALUE) {
    status = PAYOUT_REQUEST_STATUSES.PENDING
  }

  payoutRequestData = Map(payoutRequestData).merge({status})

  if (shouldAllowExpertless) {
    payoutRequestData = payoutRequestData
      .set('expert', null)
      .set('expertName', null)
  }

  payoutRequestData = payoutRequestData.toJS()

  if (shouldUpdateSession) {
    return firedux.ref.child(STRIPE_PAYOUT_REQUESTS_ENDPOINT).push(payoutRequestData)
      .then(updateSessionWithPayoutRequest.bind(null, status, payoutRequestData.sessionId))
  }
  else {
    return firedux.ref.child(STRIPE_PAYOUT_REQUESTS_ENDPOINT).push(payoutRequestData)
      .then((snapshot) => snapshot.key())
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/send_payout_request.js
 **/